/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const poaAttorneyHeaderStyle = {
  headerContainer: {
    paddingBottom: "20px",
  },
  text: {
    textAlign: { xs: "center", md: "left" },
  },
  imageCircleContainer: {
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    width: "100px",
    height: "100px",
    padding: "36px",
    borderRadius: "50% !important",
    "& > img": {
      maxHeight: "100px",
    },
  },
};

export default poaAttorneyHeaderStyle;
